import React from "react";

import { User } from "../../../../types";
import { TeamSummary } from "../../../../types.new";
import UsersTable from "./users-table";

interface UsersTableViewProps {
  team: TeamSummary;
  filteredUsers: User[];
  unfilteredUsersCount: number;
  canEdit: boolean;
}

const UsersTableView: React.FC<UsersTableViewProps> = ({
  team,
  filteredUsers,
  unfilteredUsersCount,
  canEdit,
}) => {
  return (
    <UsersTable
      team={team}
      filteredUsers={filteredUsers}
      unfilteredUsersCount={unfilteredUsersCount}
      canEdit={canEdit}
    />
  );
};

export default UsersTableView;
